import React from 'react';
import colors from '../../theme/colors';

const ranges = [
  { value: '-1h', label: '1h' },
  { value: '-6h', label: '6h' },
  { value: '-24h', label: '24h' },
  { value: '-7d', label: '7d' },
];

export default function TimeRangeSelector({ selected, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {ranges.map((r) => (
        <button
          key={r.value}
          onClick={() => onChange(r.value)}
          style={{
            padding: '5px 14px',
            borderRadius: 6,
            border: 'none',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            background: selected === r.value ? colors.accent : colors.surface,
            color: selected === r.value ? colors.bg : colors.textMuted,
            transition: 'all 0.15s',
          }}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
